import { render, staticRenderFns } from "./WidgetTemplatesPage.vue?vue&type=template&id=72403b10&scoped=true&"
import script from "./WidgetTemplatesPage.vue?vue&type=script&lang=js&"
export * from "./WidgetTemplatesPage.vue?vue&type=script&lang=js&"
import style0 from "./WidgetTemplatesPage.vue?vue&type=style&index=0&id=72403b10&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72403b10",
  null
  
)

export default component.exports